module.exports = __webpack_public_path__ + "img/Shaws-Logo-Blue.2e6ab2af.svg";